export default {
    GET_USER_PROFILE_LOADING: 'GET_USER_PROFILE_LOADING',
    GET_USER_PROFILE_SUCCESS: 'GET_USER_PROFILE_SUCCESS',
    GET_USER_PROFILE_FAILED: 'GET_USER_PROFILE_FAILED',
    GET_USER_PROFILE_REJECT: 'GET_USER_PROFILE_REJECT',

    EDIT_USER_PROFILE_LOADING: 'EDIT_USER_PROFILE_LOADING',
    EDIT_USER_PROFILE_SUCCESS: 'EDIT_USER_PROFILE_SUCCESS',
    EDIT_USER_PROFILE_FAILED: 'EDIT_USER_PROFILE_FAILED',
    EDIT_USER_PROFILE_REJECT: 'EDIT_USER_PROFILE_REJECT',
  };